module.exports = __webpack_public_path__ + "static/media/dc_1.4072f43d.jpg";